import { defineMessages } from 'react-intl';

const messages: {
	topicDownIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	topics: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	topicUpIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	topics: {
		id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topics',
		defaultMessage: 'Topics',
		description:
			'The label on the button that opens the topics drop-down in the help center navigation bar.',
	},
	topicDownIcon: {
		id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicDownIcon',
		defaultMessage: 'Open topics dropdown',
		description:
			'The accessible label for the chevron-down icon on the button that opens the topics drop-down in the navbar navigation.',
	},
	topicUpIcon: {
		id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicUpIcon',
		defaultMessage: 'Close topics dropdown',
		description:
			'The accessible label for the chevron-up icon on the button that closes the topics accordion in the mobile navigation menu.',
	},
});

export default messages;
